
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-width":"1.21","d":"M5.994 1.845h5.012c.16 0 .314.064.427.177l3.545 3.544a.6.6 0 0 1 .177.428v5.012c0 .16-.063.314-.177.427l-3.545 3.545a.6.6 0 0 1-.427.177H5.994a.6.6 0 0 1-.428-.177l-3.544-3.545a.6.6 0 0 1-.177-.427V5.994c0-.16.064-.314.177-.428l3.544-3.544a.6.6 0 0 1 .428-.177Z"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-width":"1.21","d":"m6.08 10.92 4.84-4.84m-4.84 0 4.84 4.84"}})])
          )
        }
      }
    